import axios from 'axios';
import {BaseResponse} from "../../BaseResponse";

export async function deleteEtcProduct(uid : string) {
    const response = await axios.delete<BaseResponse<boolean>>(`/basic/etc_product/${uid}`)

    return response.data
}

